"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import { Zap, Bot } from "lucide-react";
export default function ServiceOfferings() {
  const {
    ref: leftCardRef,
    isVisible: leftVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: rightCardRef,
    isVisible: rightVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2,
    rootMargin: "0px 0px -50px 0px"
  });
  const services = [{
    icon: Bot,
    title: "AI-Driven Automation Architecture",
    description: "Custom-built intelligent systems that eliminate repetitive tasks and administrative friction, letting you focus on what truly matters—your creative mission."
  }, {
    icon: Zap,
    title: "Masterclass Residency Programs",
    description: "Intensive on-site engagements where we transform your team's workflow with hands-on training, strategic implementation, and lasting operational efficiency."
  }];
  return <section className="relative bg-[#0A0A0A] py-24 px-6 overflow-hidden">
      {}
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{
      backgroundImage: `linear-gradient(hsla(0, 0%, 100%, 0.05) 1px, transparent 1px), linear-gradient(90deg, hsla(0, 0%, 100%, 0.05) 1px, transparent 1px)`,
      backgroundSize: "40px 40px",
      transform: "translateY(calc(var(--scroll) * 0.1))"
    }} />

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="grid md:grid-cols-2 gap-8">
          {services.map((service, i) => {
          const Icon = service.icon;
          const ref = i === 0 ? leftCardRef : rightCardRef;
          const isVisible = i === 0 ? leftVisible : rightVisible;
          return <div key={i} data-index={i} ref={ref} className="transition-all duration-200 ease-[cubic-bezier(0.4,0,0.2,1)]" style={{
            opacity: isVisible ? 1 : 0,
            transform: isVisible ? "translateY(0)" : "translateY(20px)"
          }}>
                <Card className="group bg-[#0A0A0A] border border-primary/20 hover:border-primary transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:scale-[1.04] hover:shadow-[0_0_30px_rgba(56,139,253,0.3)] relative overflow-hidden">
                  <CardHeader>
                    <div className="mb-4">
                      <Icon className="w-12 h-12 text-primary" strokeWidth={1.5} />
                    </div>
                    <CardTitle className="text-2xl font-display text-foreground-dark mb-2">
                      {service.title}
                    </CardTitle>
                    <CardDescription className="text-foreground-dark/70 text-base leading-relaxed">
                      {service.description}
                    </CardDescription>
                  </CardHeader>
                  
                  {}
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-primary via-secondary to-accent transform origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-[var(--duration-medium)] ease-[var(--ease-spring)]" />
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}